import React, { PureComponent } from 'react';
import Radium from 'radium';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { shape, string, bool } from 'prop-types';

import { actionCreators as UtilityActions } from 'redux/utility/actions';
import { ROUTES } from 'constants/routes';
import Sidebar from 'app/components/Sidebar';
import Topbar from 'app/components/Topbar';

import PendingFineAmountQuery from '../../components/PendingFineAmountQuery';
import PendingWarrantyDepositQuery from '../../components/PendingWarrantyDepositQuery';
import NewComplaint from '../Dashboard/screens/Complaints/screens/NewComplaint';
import { appConfig } from '../../../config/customization';
import AppDownloader from '../AppDownloader';

import Payments from './screens/Payments';
import PaymentRequest from './screens/PaymentRequest';
import PaymentDocuments from './screens/PaymentDocuments';
import SocialRate from './screens/SocialRate';
import Complaints from './screens/Complaints';
import LastBillQuery from './screens/LastBillQuery';
import BalanceQuery from './screens/BalanceQuery';
import Home from './screens/Home';
import ChangeDueDate from './screens/ChangeDueDate';
import PaymentByNis from './screens/PaymentByNis';
import styles from './styles';

class PublicDashboard extends PureComponent {
  componentWillMount = () => this.props.dispatch(UtilityActions.getComplaintForm());

  render() {
    return (
      <div style={styles.base}>
        <div style={styles.baseContent}>
          <Topbar />
          <Sidebar location={this.props.location} />
          {this.props.displayAdvice && appConfig.withAppDownloader && <AppDownloader />}
          <div style={styles.content}>
            <Switch>
              {appConfig.publicDashboard.home && <Route exact path={ROUTES.PUBLIC_HOME} component={Home} />}
              <Route exact path={ROUTES.PUBLIC_PAYMENTS} component={Payments} />
              <Route exact path={ROUTES.PUBLIC_PAYMENT_DOCUMENTS} component={PaymentDocuments} />
              {appConfig.payments.publicPaymentByNis && (
                <Route exact path={ROUTES.PUBLIC_PAYMENTS_BY_NIS} component={PaymentByNis} />
              )}
              {appConfig.publicDashboard.complaints && (
                <Route exact path={ROUTES.PUBLIC_COMPLAINTS} component={Complaints} />
              )}
              {appConfig.publicDashboard.socialRate && (
                <Route exact path={ROUTES.PUBLIC_SOCIAL_RATE} component={SocialRate} />
              )}
              {appConfig.publicDashboard.pendingWarrantyDepositQuery && (
                <Route
                  exact
                  path={ROUTES.PUBLIC_PENDING_WARRANTY_DEPOSIT_QUERY}
                  component={PendingWarrantyDepositQuery}
                />
              )}
              {appConfig.publicDashboard.pendingFineAmountQuery && (
                <Route
                  exact
                  path={ROUTES.PUBLIC_PENDING_FINE_AMOUNT_QUERY}
                  component={PendingFineAmountQuery}
                />
              )}
              {appConfig.publicDashboard.complaints && (
                <Route exact path={ROUTES.PUBLIC_NEW_COMPLAINT} component={NewComplaint} />
              )}
              {appConfig.publicDashboard.lastBillQuery && (
                <Route exact path={ROUTES.PUBLIC_LAST_BILL_QUERY} component={LastBillQuery} />
              )}
              {appConfig.publicDashboard.balanceQuery && (
                <Route exact path={ROUTES.PUBLIC_BALANCE_QUERY} component={BalanceQuery} />
              )}
              {appConfig.publicDashboard.changeDueDate && (
                <Route exact path={ROUTES.PUBLIC_CHANGE_DUE_DATE} component={ChangeDueDate} />
              )}
              {appConfig.payments.active && (
                <Route exact path={ROUTES.PUBLIC_PAYMENT_REQUEST} component={PaymentRequest} />
              )}
              <Route
                render={() => (
                  <Redirect
                    to={appConfig.publicDashboard.home ? ROUTES.PUBLIC_HOME : ROUTES.PUBLIC_PAYMENTS}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  displayAdvice: store.device.isMobile && !store.device.adviceSubmitted
});

PublicDashboard.propTypes = {
  location: shape({
    pathname: string.isRequired
  }).isRequired,
  displayAdvice: bool
};

export default connect(mapStateToProps)(Radium(PublicDashboard));
